import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { ContractStatusBadge, moneyFigure } from './rowBadges';

import { formatDateWithYear } from 'Helpers/dateTimeService';

/**
 * The user's contracts, in the Contracts screen's own columns.
 *
 * `unsigned` is read from the row rather than compared against the status text:
 * `status` is translated, so matching it against the string "Unsigned" would
 * quietly stop flagging anything the moment the page is served in Arabic.
 *
 * Rows arrive unsigned-first; nothing is re-sorted here. Per-row values only.
 *
 * EVERY ROW OPENS, INCLUDING THE ONE WITH NO `href`. This table carried the
 * only null-`href` guard in the eight, because a revenue contract opens on a
 * screen behind `department.scope` and a department-restricted user is refused
 * it outright — so that row rendered with no Open control at all.
 *
 * The row now opens a pop-up rather than navigating, and the pop-up resolves
 * through the same scope that produced the row, so it always opens. Whether a
 * MODULE link is offered inside it is the server's decision (`module_link`,
 * null for exactly that user), which is where the question belongs. `row.href`
 * is not read here, and reintroducing a guard on it would take the one route
 * into the record away from the user it was meant to protect.
 */
export default function ContractSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Contract')}</th>
                        <th>{$t('Supplier')}</th>
                        <th className="tw-w-40">{$t('Value')}</th>
                        <th className="tw-w-36">{$t('End date')}</th>
                        <th className="tw-w-32">{$t('Status')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: row.unsigned })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.reference })}>
                                    {row.reference}
                                </OpenRowButton>
                            </td>
                            <td>{orNotSet(row.supplier)}</td>
                            <td className="inbud-numeric-cell">{moneyFigure(row.value)}</td>
                            <td className="inbud-date-cell">{orNotSet(row.end_date && formatDateWithYear(row.end_date))}</td>
                            <td>
                                <ContractStatusBadge status={row.status} unsigned={row.unsigned} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
